/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { Input } from "antd";
import { FAQCard } from "../../../components";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
interface FAQInterface {
  question: string;
  answer: string;
}

const FAQPage = () => {
  const { t } = useTranslation();

  const mockFAQ: FAQInterface[] = useMemo(() => {
    const faqList = t("faqs.questions_list", {
      returnObjects: true,
    }) as FAQInterface[];
    return faqList;
  }, [t]);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredFAQ, setFilteredFAQ] = useState(mockFAQ);

  const handleSearch = (value: string) => {
    setSearchQuery(value);

    const filtered = mockFAQ.filter((faq) =>
      faq.question.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredFAQ(filtered);
  };
  useEffect(() => {
    const filtered = mockFAQ.filter((faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredFAQ(filtered);
  }, [mockFAQ, searchQuery]);
  return (
    <div>
      <div className="w-full py-8 px-4 text-center text-white bg-gradient-to-b from-[#F00D0D] to-[#994F4F]">
        <h1 className="text-[32px] font-bold mb-2">{t("faqs.title")}</h1>
        <p className="text-[22px] font-bold">{t("faqs.subtitle")}</p>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-20 flex flex-col justify-center items-center gap-10">
        <FAQSearchBar t={t} onSearch={handleSearch} />

        <p className="w-full text-primary-blue text-xl font-bold">
          {t("faqs.questions_list_title")}
        </p>

        {filteredFAQ.length === 0 ? (
          <p className="text-center text-lg text-gray-500">
            No questions found
          </p>
        ) : (
          <div className="w-full grid md:grid-cols-2 gap-6">
            <div className="flex flex-col gap-6">
              {filteredFAQ
                .slice(0, Math.ceil(filteredFAQ.length / 2))
                .map((faq, index) => (
                  <FAQCard
                    key={index}
                    question={faq.question}
                    answer={faq.answer}
                  />
                ))}
            </div>
            <div className="flex flex-col gap-6">
              {filteredFAQ
                .slice(Math.ceil(filteredFAQ.length / 2))
                .map((faq, index) => (
                  <FAQCard
                    key={index}
                    question={faq.question}
                    answer={faq.answer}
                  />
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQPage;

const FAQSearchBar = ({
  t,
  onSearch,
}: {
  t: any;
  onSearch: (value: string) => void;
}) => {
  return (
    <div className="w-full max-w-5xl mb-10">
      <Input.Search
        placeholder={t("faqs.search_hint")}
        enterButton
        size="large"
        onSearch={onSearch}
      />
    </div>
  );
};

// const mockFAQ: FAQInterface[] = [
//   {
//     question:
//       "Which electronic information page should I access to apply for an electronic visa for Viet Nam?",
//     answer:
//       "If you need to apply for an electronic visa to enter Viet Nam, please access Viet Nam's electronic visa information page at the following addresses: https://evisa.gov.vn or https://thithucdientu.gov.vn to complete the procedure. Make sure to visit the correct website to avoid accessing unofficial electronic information pages, which may result in unauthorized fees according to Viet Nam's regulations."
//   },
//   {
//     question:
//       "What are the conditions to apply for an electronic visa, and how long can an electronic visa be granted for?",
//     answer:
//       "According to the regulations of the Law on Entry, Exit, Transit, and Residence of Foreigners in Viet Nam in 2014 (amended in 2019, 2023), an electronic visa is granted to foreigners with passports who do not fall under provisions in Articles 8(1), (2), (3), and (4) and who are not subject to conditions for entry denial under Article 21 of the Law. Therefore, you need to meet these conditions to be eligible for an electronic visa. Regarding the validity period, according to the Law, the visa cannot exceed 90 days, and you should note that the validity of the electronic visa must be at least 30 days shorter than the passport validity."
//   },
//   {
//     question:
//       "When filling out my name on the electronic visa application form, do I need to include my middle name?",
//     answer:
//       "You need to provide your full name, including your surname, middle name, and given name, exactly as it appears on the ICAO line in your passport, using uppercase letters."
//   },
//   {
//     question:
//       "When filling out my name on the electronic visa application form, do I need to include my middle name?",
//     answer:
//       "Electronic visas are issued to foreigners who wish to enter Vietnam (not applicable to foreigners currently residing in Vietnam). Therefore, after departing and exiting Vietnam, you may request an electronic visa."
//   },
//   {
//     question:
//       "In section 6.9, regarding detailed reporting of trips, can I combine information for periods within the last year if they serve the same purpose of the trip?",
//     answer:
//       "The applicant must declare and provide complete, accurate, and truthful information in response to all questions on the declaration form. Regarding section 6.9, the applicant needs to detail information about trips taken within the past year (if any); the duration of each trip is calculated from the date of entry to the date of departure."
//   },
//   {
//     question:
//       "If I enter Vietnam and plan to temporarily reside in multiple locations as part of a tour, how do I declare my temporary addresses?",
//     answer:
//       "If you plan to temporarily reside in multiple locations, you must declare the first address where you will stay temporarily. After entering Vietnam, you must go through the direct manager or operator of the accommodation establishment to declare your temporary residence according to Vietnamese law (this must be done each time you change your temporary residence location)."
//   },
//   {
//     question:
//       "Do I have to declare my past violation history from a long time ago during my previous entry?",
//     answer:
//       "You must declare complete, accurate, and truthful information on the declaration form. If you fail to do so, including disclosing any past violation history from previous entries, you may be denied an electronic visa."
//   },
//   {
//     question:
//       "I was granted a multiple-entry electronic visa valid for up to 90 days, but when going through immigration, I forgot to present my electronic visa and was allowed entry under visa exemption. Can I return to the border gate to update the duration of my temporary residence certificate according to my electronic visa?",
//     answer:
//       "To ensure compliance with Vietnam's immigration regulations and safeguard your rights, you must present valid residence documents (such as an electronic visa) to immigration officers at the border. Additionally, carefully check the temporary residence certificate stamped in your passport and promptly notify immigration control at the border if any information is inaccurate."
//   },
//   {
//     question: "Can I apply for an electronic visa to work?",
//     answer:
//       "According to Vietnamese law, foreigners working in Vietnam must have a work permit or a confirmation that they do not require a work permit as stipulated by the Labor Code."
//   },
//   {
//     question:
//       "Can I apply for an electronic visa more than 1 year before the planned entry?",
//     answer:
//       "To proactively arrange your schedule, you may apply for an electronic visa up to 1 year before your planned entry."
//   },
//   {
//     question:
//       "I plan to use an electronic visa to enter through Noi Bai International Border Gate. Am I required to exit through Noi Bai International Border Gate as well?",
//     answer:
//       "Foreigners using an electronic visa are not required to exit Vietnam through the same border gate where they entered. Note that foreigners must enter and exit Vietnam through international border gates designated by the government, as listed in the Overview Introduction section."
//   }
// ];
